export default {
  'YouTube and High Definition Videos': 'Video YouTube e Ad Alta Definizione',
  'Story videos (Instagram/Snaps/TikTok)': 'Storie Video (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Feed Video Facebook e Instagram',
  'Facebook and Twitter Portrait Videos': 'Ritratti Video Facebook e Twitter',
  'Twitter and Facebbok Landscape Videos': 'Paesaggi Video Twitter e Facebbok',
  'Facebook Cover Videos And Blog Banners': 'Copertina Video Facebook e Banner Blog',
  'Fit': 'Adatta',
  'Fill': 'Riempi',
}